// countryCodes.js
export const countryCodes = [
  { code: "+92", name: "Pakistan", flag: "🇵🇰" },          // PKR
  { code: "+970", name: "Palestine", flag: "🇵🇸" },        // ILS
  { code: "+880", name: "Bangladesh", flag: "🇧🇩" },       // BDT
  { code: "+91", name: "India", flag: "🇮🇳" },             // INR
  { code: "+93", name: "Afghanistan", flag: "🇦🇫" },       // AFN
  { code: "+967", name: "Yemen", flag: "🇾🇪" },            // YER
  { code: "+963", name: "Syria", flag: "🇸🇾" },            // SYP
  { code: "+98", name: "Iran", flag: "🇮🇷" },              // IRR
  { code: "+964", name: "Iraq", flag: "🇮🇶" },             // IQD
  { code: "+962", name: "Jordan", flag: "🇯🇴" },           // JOD
  { code: "+961", name: "Lebanon", flag: "🇱🇧" },          // LBP
  { code: "+20", name: "Egypt", flag: "🇪🇬" },             // EGP
  { code: "+249", name: "Sudan", flag: "🇸🇩" },            // SDG
  { code: "+90", name: "Turkey", flag: "🇹🇷" },            // TRY
];

export default countryCodes;